export const __DEV__ = process.env.NODE_ENV === 'development';

export const JOURNALER_API = __DEV__ ? 'http://localhost:3000' : 'https://journaler.aem.ac'

export const API = {
    HELP_CENTER: JOURNALER_API +'/api/website/help-center'
}
